import api from '../../api/restaurant/restaurantInventoryApi';
import {
  CustomResponse,
  RestaurantInventoryDTO,
  RestaurantInventoryFilters,
  RestaurantInventoryForm,
  RestaurantInventoryPage,
} from '../../types/restaurant/RestaurantInventoryTypes';
import { appendRestaurantQuery } from './restaurantPageQuery';

const optionalNumber = (value: number | '') =>
  value === '' ? null : Number(value);

const valuesPayload = (form: RestaurantInventoryForm) => ({
  currentStock: optionalNumber(form.currentStock),
  minimumStock: optionalNumber(form.minimumStock),
  maximumStock: optionalNumber(form.maximumStock),
  averageCost: optionalNumber(form.averageCost),
  lastPurchaseCost: optionalNumber(form.lastPurchaseCost),
});

const RestaurantInventoryService = {
  list: async (
    branchId: number,
    filters: RestaurantInventoryFilters = {},
  ) => {
    const query = appendRestaurantQuery(new URLSearchParams({
      page: String(filters.page ?? 0),
      size: String(filters.size ?? 20),
      activeOnly: String(filters.activeOnly ?? false),
      lowStockOnly: String(filters.lowStockOnly ?? false),
    }), {
      rawMaterialId: filters.rawMaterialId,
      categoryId: filters.categoryId,
      search: filters.search?.trim(),
    });
    return (await api.fetchCustom(`/branches/${branchId}?${query.toString()}`))
      .data as RestaurantInventoryPage;
  },
  get: async (id: number) =>
    (await api.fetchById(id)).data as CustomResponse<RestaurantInventoryDTO>,
  create: async (branchId: number, form: RestaurantInventoryForm) =>
    (await api.addCustom(`/branches/${branchId}`, {
      rawMaterialId: Number(form.rawMaterialId),
      ...valuesPayload(form),
    })).data as CustomResponse<RestaurantInventoryDTO>,
  update: async (id: number, form: RestaurantInventoryForm) =>
    (await api.modify(id, valuesPayload(form))).data as CustomResponse<RestaurantInventoryDTO>,
  updateActive: async (id: number, active: boolean) =>
    (await api.patchCustom(`${id}/active`, { active })).data as CustomResponse<RestaurantInventoryDTO>,
};

export default RestaurantInventoryService;
